module.exports = __webpack_public_path__ + "assets/f8742cd1bb47dc6909478864798bc9b2.png";